export default {
    buildMinRestrictionsMessage: (min) => `Введите дату не раннее ${min}`,
    buildMaxRestrictionsMessage: (max) => `Введите дату не позднее ${max}`,
    buildMinMaxRestrictionsMessage: (min, max) => `Введите дату в диапазоне от ${min} до ${max}`
};
